import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { GiNewspaper } from "react-icons/gi";
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <GiNewspaper color="red" size="3rem" />
          <div className="logo-text">
            <h1>BookMyNewsAd</h1>
            <span className="tagline">Trusted Newspaper Advertising Since 1998.</span>
          </div>
        </Link>
        
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className={isActive('/')} onClick={() => setIsMenuOpen(false)}>Home</Link>
          <Link to="/about" className={isActive('/about')} onClick={() => setIsMenuOpen(false)}>About Us</Link>
          <Link to="/pricing" className={isActive('/pricing')} onClick={() => setIsMenuOpen(false)}>Pricing</Link>
          <Link to="/samples" className={isActive('/samples')} onClick={() => setIsMenuOpen(false)}>Ad Samples</Link>
          <Link to="/blog" className={isActive('/blog')} onClick={() => setIsMenuOpen(false)}>Blog</Link>
          <Link to="/contact" className={`${isActive('/contact')}`} onClick={() => setIsMenuOpen(false)}>Contact Us</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
